import type { GroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'
import { useContext } from 'use-context-selector'

import GroupingContext from 'components/Editor/EditorElements/elements/Grouping/GroupingContext'
import { useProjectT } from 'services/ProjectLabels'
import { useUrlByUsage } from 'utils/files'

import * as s from './Answer.module.scss'

interface IAnswerProps {
  item: GroupingItem
}
const Answer = ({ item }: IAnswerProps) => {
  const pt = useProjectT()
  const { styles, hasAnswerImage, font } = useContext(GroupingContext)
  const imgUrl = useUrlByUsage(item.image, FileUsageTypeEnum.image)
  const labelClasses = cn(s.answer, { [s.placeholder]: !item.label })
  const label =
    item.label || (item?.image?.id && hasAnswerImage)
      ? item.label || ''
      : pt('elements.grouping.answer.placeholder')
  const textStyles = item.label && { ...font?.base }

  return (
    <div
      className={labelClasses}
      style={{
        ...styles.answer,
        ...textStyles,
        padding: styles.indents.padding,
        backgroundImage: imgUrl && hasAnswerImage ? `url(${imgUrl})` : undefined,
      }}
    >
      <div className={s.mask} style={{ backgroundColor: item.overlay || undefined }} />
      <span className={s.label}>{label}</span>
    </div>
  )
}
export default Answer
